const { lazy } = require("react");

export const MainPage = lazy(() => import('~/screens/mainpage'));
export const Homepage = lazy(() => import('~/screens/homepage'));

export const ROUTES = {
    MainPage: '/mainpage',
    Homepage: '/',
};